
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import { PersonenRolle } from '@/types/PersonenRolle';
    import Person from '@/types/Person';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { VForm } from '@/types/Components';
    import { DeletePersonPayload, PersonenFilter, UpdatePersonPayload } from '@/store/personen';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('personen', ['loaders']),
            ...mapState('authentication', ['impfstelle_id']),
        },
        methods: {
            ...mapActions('personen', ['updatePerson', 'deletePerson']),
            ...mapMutations('personen', ['setDialogsDetail']),
        },
    })
    export default class PersonenDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() person!: Person;
        @Prop() filter!: PersonenFilter;

        public $refs!: {
            form: VForm;
            signatur: Vue;
        };

        public impfstelle_id!: number;
        public updatePerson!: (payload: UpdatePersonPayload) => void;
        public deletePerson!: (payload: DeletePersonPayload) => void;

        public get isEdit(): boolean {
            return this.person.person_id !== null;
        }

        public rollen: { text: string; value: PersonenRolle }[] = [
            { text: 'Arzt', value: PersonenRolle.Arzt },
            { text: 'Assistenz', value: PersonenRolle.Assistenz },
        ];

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }

                if (this.$refs.signatur) {
                    (this.$refs.signatur.$refs.input as HTMLInputElement).style.height = '';
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.person.impfstelle_id = this.impfstelle_id;
                this.updatePerson({ person: this.person, filter: this.filter });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Person endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deletePerson({ person: this.person, filter: this.filter });
                    }
                });
        }
    }
